module.exports = __webpack_public_path__ + "static/media/ic-disabled.2303ccb6.svg";